import React from 'react'
import data from '../meme.js'

const Form = () => {
    let [meme, setMeme] = React.useState({
        topText: '',
        bottomText: '',
        randomImg: 'http://i.imgflip.com/1bij.jpg'
    })

    let [allMemeImages, setAllmemeImages] = React.useState(data)

    const handleClick = (e) => {
        let random_num = Math.floor(Math.random() * allMemeImages.data.memes.length) + 1
        let url = allMemeImages.data.memes[random_num].url
        setMeme(prevstate => ({ ...prevstate, randomImg: url }))
    }

    const handleChange = (e) => { setMeme(prev => ({ ...prev, [e.target.name]: e.target.value })) }
    return (
        <div className="form">
            <div className='container'>
                <input type='text' placeholder="top text" className='form_input' name='topText' onChange={handleChange} value={meme.topText} />
                <input type='text' placeholder="bottom text" className='form_input' name='bottomText' onChange={handleChange} value={meme.bottomText} />
            </div>
            <div className='button' onClick={handleClick}><div className='buttonText'>Get a new meme image</div></div>
            <div className='memeImage'><img src={meme.randomImg} alt='meme' className='image' />
                <p className='top'>{meme.topText}</p>
                <p className='bottom'>{meme.bottomText}</p>

            </div>
        </div >
    )
}

export default Form;